/**
 * @Author: Alex Sorafumo <Yuion>
 * @Date:   12/12/2016 10:41 AM
 * @Email:  alex@yuion.net
 * @Filename: stepper.component.ts
 * @Last modified by:   alex.sorafumo
 * @Last modified time: 20/01/2017 3:45 PM
 */

import { Component, EventEmitter, Input, Output, QueryList, ContentChildren} from '@angular/core';

import { StepperStepComponent } from './step.component';
import { BaseWidgetComponent } from '../../../shared/base.component';

@Component({
    selector: 'stepper',
    template: `<div [class]="'stepper ' + name" [class.vertical]="format === 'vertical' || format === 'vert'" widget>
    <div class="progress" [class.vertical]="format === 'vertical' || format === 'vert'">
        <div class="node" [class.vertical]="format === 'vertical' || format === 'vert'"  *ngFor="let step of step_list; let i = index" (touchrelease)="toStep(i)">
            <div class="bar" [style.opacity]="i === 0 ? 0 : 1"></div>
            <div class="state" [class.active]="step.state === 'active'" [class.success]="step.state === 'done'" [class.error]="step.state === 'error'">
                <span *ngIf="numbers">{{i + 1}}</span>
            </div>
            <div class="bar" [style.opacity]="i >= step_list.length - 1 ? 0 : 1"></div>
        </div>
    </div>
    <div class="content" [class.vertical]="format === 'vertical' || format === 'vert'">
        <ng-content></ng-content>
    </div>
</div>`,
    styles: [`@charset "UTF-8";.stepper{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.stepper.vertical{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;width:100%;height:100%}.progress{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.progress.vertical{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-right:.5em}.node{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex:1;flex:1}.node.vertical{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.node.vertical .bar{min-height:1em;min-width:0}.node .bar{-webkit-box-flex:1;-ms-flex:1;flex:1;width:2px;height:2px;background-color:rgba(0,0,0,.2);min-width:1em}.state{height:1.5em;min-height:1.5em;width:1.5em;min-width:1.5em;margin:.2em;border-radius:55%;color:#fff;background-color:#ccc;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-transition:background-color .3s;transition:background-color .3s}.state.active{background-color:#ff9800;cursor:default}.state.error{background-color:#f44336}.state.error span{display:none}.state.error:after{content:'╳';font-size:.6em}.state.success{background-color:#4caf50}.state.success span{display:none}.state.success:after{content:'✓'}.content{position:relative;overflow-x:hidden;width:100%;min-height:5em}.content.vertical{height:100%;overflow-y:auto}`],
})
export class StepperComponent extends BaseWidgetComponent {
    @Input() public step = 0;
    @Input() public numbers = true;
    @Input() public format: 'horizontal' | 'vertical' | 'vert' | 'horz' = 'horizontal';
    @Output() public stepChange = new EventEmitter();

    @ContentChildren(StepperStepComponent) private steps: QueryList<StepperStepComponent>;

    public step_list: StepperStepComponent[] = [];

    public ngAfterContentInit() {
        this.update();
    }

    public update() {
        if (this.steps) {
            const items = this.steps.toArray();
            this.step_list = [...items];
            for (const step of this.step_list) {
                step.parent = this;
            }
            this.toStep(this.step, false);
        }
    }

    public toStep(index: number, change: boolean = true) {
        const reverse = index < this.step;
        const dir = `${this.format === 'vertical' ? 'vert' : 'horz'}${reverse ? '-reverse' : ''}`;
        for (let i = 0; i < this.step_list.length; i++) {
            this.step_list[i].model.direction = dir;
        }
        setTimeout(() => {
            for (let i = 0; i < this.step_list.length; i++) {
                this.step_list[i].setActive(i === index);
            }
        }, 10);
        this.step = index;
        if (change) {
            this.stepChange.emit(index);
        }
    }
}
